import { Quote } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

export const Testimonials = () => {
  const { t } = useLang();
  const items = [
    { quote: t.testimonials.t1, author: t.testimonials.t1Author, role: t.testimonials.t1Role },
    { quote: t.testimonials.t2, author: t.testimonials.t2Author, role: t.testimonials.t2Role },
    { quote: t.testimonials.t3, author: t.testimonials.t3Author, role: t.testimonials.t3Role },
  ];

  return (
    <section
      data-testid="testimonials-section"
      className="py-20 lg:py-28 border-t border-stone-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="font-mono-label text-stone-500">
            {t.testimonials.eyebrow}
          </span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-900 leading-tight">
            {t.testimonials.title}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i + 1}`}
              className="bg-white border border-stone-200 rounded-2xl p-8 flex flex-col"
            >
              <Quote className="text-red-800" size={22} />
              <blockquote className="mt-4 text-stone-800 leading-relaxed flex-1">
                {it.quote}
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-stone-200">
                <p className="font-display text-stone-900">{it.author}</p>
                <p className="text-sm text-stone-500 mt-0.5">{it.role}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
